export default {
  assistant: {
    title: 'flexiAI',
    subtitle: 'Operasyon asistanı',
    close: 'Kapat',
    newChat: 'Yeni sohbet',
    emptyHint: 'Rotalar, seferler, gecikmeler, yolcular ve rezervasyonlar hakkında soru sorun. Tüm yanıtlar canlı veriden, sizin yetkilerinizle gelir.',
    inputPlaceholder: 'Bugünkü operasyonla ilgili sorun…',
    thinking: 'İnceliyorum…',
    toolRunning: '{name} kontrol ediliyor…',
    toolFailed: '{name} başarısız oldu',
    sessionExpired: 'Flexigo oturumunuzun süresi doldu. Asistanı kullanmaya devam etmek için yeniden giriş yapın.',
    reload: 'Yeniden giriş yap',
    busy: 'Önceki sorunuz üzerinde çalışıyorum — bir dakika.',
    dailyLimit: 'Bugünkü asistan limitine ulaştınız. Gece yarısı sıfırlanır.',
    disabled: 'Asistan şu anda kapalı.',
    unavailable: 'Asistana şu anda ulaşılamıyor. Az sonra tekrar deneyin.',
    errorGeneric: 'Bir sorun oluştu. Lütfen tekrar deneyin.',
    disclaimer: 'flexiAI hata yapabilir — kritik detayları uygulamadan önce doğrulayın.',
    prompts: {
      late: 'Şu anda hangi rotalar gecikmede?',
      today: 'Bugünkü operasyon genel olarak nasıl gidiyor?',
      live: 'Bir rotanın canlı durumunu göster',
      history: 'Son iki haftada sürekli geciken rota var mı?',
      approvals: 'Onayımı bekleyen bir şey var mı?',
      tickets: 'Bir rotada yolcular nelerden şikayetçi olmuş?',
      stops: 'Bir rotanın duraklarını sırayla göster',
      rider: 'Bir yolcu hangi rotaya atanmış?',
    },
  },
};
